/**
 * Common - Biblioteca JavaScript Global
 *
 * Carregado em todos os contextos: admin, front, gestao.php, clean.php
 *
 * @package Labead
 */

// Sistema centralizado de logging (exposto como window.lbLog)
import './parts/common/lbLog.js';

// Lucide Icons - Inicializa ícones via CDN
import './parts/lucide-icons.js';

// Barra do WordPress rola com a página no celular (gestão + área do aluno).
import './parts/common/adminbar-mobile.js';

// Sessão vencida (window.lbSession): aviso + volta ao login com redirect_to,
// no lugar do toast técnico de nonce/cookie. Antes do lbalert/lbform porque
// os dois consultam window.lbSession.
import './parts/common/session-expired.js';

// Continuando em gestao, lbform, toast, lmsg, lbbalao (mascote), load.
import './parts/common/sons.js';// window.lbSonsMudos — silenciar vale para todos os sons (antes de quem toca).
import './parts/common/mascote.js';// window.lbMascote — imagem da mascote por ação (antes do lbalert).
import './parts/common/lb-carregando.js';// window.lbCarregando — carregando único com a mascote (Core\Components\Carregando).
import './parts/common/lbalert.js';// Alertas e toasts mascote + lbDestacarCampo (erro no campo).
import './parts/common/lb-flutuante.js';// lbPosicionar, dica (data-lb-dica), lbFlutuante (menus), lbArrastarFechar.
import './parts/common/lb-janela.js';// window.lbJanela — comportamento da janela única (Core\Components\Janela).
import './parts/common/send-acesso.js';// window.lbSendAcesso — enviar dados de acesso (equipe/alunos).
import './parts/common/user-settings.js';// window.lbChangeUserEmail / lbChangeUserPassword — forçar alteração (equipe/alunos).
import './parts/common/lmsg-toast.js';// Toasts legado.
import './parts/common/lbform.js';
import './parts/common/masks.js';// Máscaras de input.
import './parts/common/extenso.js';// window.lbExtenso — número por extenso (PT-BR).
import './parts/common/autocep.js';// Auto preenchimento de endereço via CEP.
import './parts/common/validation.js';
import './parts/common/confetti.js';// Efeito de confete (window.lbConfetti).
import './parts/components/lb-avatar.js';// <lb-avatar> — avatar universal (gestão + área do aluno).

// algumas funções serão removidas, mas por enquanto ficam aqui para não quebrar nada
import './parts/common/utils.js';

// Carrega dinamicamente libs JS (ex: select2, flatpickr, etc).
//import './parts/libs/libs.js';

// Components.
// Embed card fullscreen viewer.
import initEmbedCard from './parts/components/embed-card.js';
initEmbedCard();
document.addEventListener('lbAjaxComplete', initEmbedCard);
document.addEventListener('htmx:afterSettle', initEmbedCard);
// Exposto p/ componentes que renderizam cards dinamicamente (ex.: lbFilesPage).
window.lbInitEmbedCard = initEmbedCard;

// .lbfield passeye (eye icon for password fields).
import initPassEye from './parts/components/passeye.js';
initPassEye();
document.addEventListener('lbAjaxComplete', initPassEye);
document.addEventListener('htmx:afterSettle', initPassEye);

// input[type=file] image editor (CropperJS standalone).
import initFileImageEditor from './parts/components/file-image-editor.js';
initFileImageEditor();
document.addEventListener('lbAjaxComplete', () => initFileImageEditor());
document.addEventListener('htmx:afterSettle', () => initFileImageEditor());
